import script from "./rightPie1.vue?vue&type=script&setup=true&lang=js"
export * from "./rightPie1.vue?vue&type=script&setup=true&lang=js"

import "./rightPie1.vue?vue&type=style&index=0&id=6e8c780a&scoped=true&lang=css"
script.__scopeId = "data-v-6e8c780a"

export default script